export default {
    
    none: null,
    delete: 'delete'
    
}